import { Link } from 'react-router-dom';
import FallbackImage from '../../../../atoms/Image/Fallback';
import Text from '../../../../atoms/Text';
import NumberDisplay from '../../../../molecules/NumberDisplay';
import { WalletTokensBySym } from '../../../../wallet/walletReducer';

// here's array of scam addresses of tokens whick should not be displayed in the balance menu
const scamAddresses = [
  '0x119e2ad8f0c85c6f61afdf0df69693028cdc10be', // Zepe.io
  '0x17b7163cf1dbd286e262ddc68b553d899b93f526', // QBT
  '0x67efef66a55c4562144b9acfcfbc62f9e4269b3e', // Cake-LP
  '0x8cad27f4a0987ff10a2a14c35154cb5407b7bfa5', // HAIR
  '0xb0557906c617f0048a700758606f64b33d0c41a6', // Zepe.io (it has 2 addresses, true scam)
  '0x5190b01965b6e3d786706fd4a999978626c19880', // EVER
  '0x442b656f5a5c3dd09790951810c5a15ea5295b51', // Tu7.org
  '0x27b880865395da6cda9c407e5edfcc32184cf429', // Dex88.org
];

const filterScam = (coins: string[], mapping: any) =>
  coins.filter(
    (item) => mapping[item] && !scamAddresses.includes(mapping[item]?.contract)
  );

/**
 * Render fallback icon
 * @param param0
 * @returns
 */
const FallbackCoinIcon = ({ name }: any) => {
  return <div className='token__fallback'>{name[0]}</div>;
};

/**
 * Render balances
 * @param mapping, balances
 * @returns
 */

interface IDexBalancesProps {
  mapping: WalletTokensBySym;
  chain: string;
  onClose(): void;
}

const DexBalances = ({ mapping, chain, onClose }: IDexBalancesProps) => {
  const tokens = filterScam(Object.keys(mapping), mapping);

  return (
    <div className='balances_coins_list'>
      {tokens.map((item) => (
        <Link
          key={item}
          className={`balances_coins_list__item ${
            mapping[item].isNative ? 'balances_coins_list__item--disabled' : ''
          }`}
          onClick={onClose}
          to={`/en/token/${chain}/${mapping[item].contract}`}
        >
          <FallbackImage
            size='l'
            src={mapping[item].icon}
            fallback={<FallbackCoinIcon name={item} />}
            props={{ style: { borderRadius: '50%' } }}
          />
          <div className='balances_coins_list__item__balance_info'>
            <Text
              style={{ title: item }}
              size={14}
              className='text--weight-600 text--grey-400'
            >
              {item} ({mapping[item].fullName})
            </Text>
            <NumberDisplay
              value={Number(mapping[item].balance)}
              textProps={{ size: 12, className: 'text--grey-400' }}
            />
          </div>
        </Link>
      ))}
    </div>
  );
};

export default DexBalances;
